export default __webpack_public_path__ + "static/media/HelveticaNeueLTW1G-Bd.e3a183e2.ttf";